import { useEffect, useState } from 'react';

interface RelativePosition {
  rightPercent: number;
  bottomPercent: number;
}

interface UsePersistedPositionProps {
  storageKey: string;
  defaultPosition: { right: number; bottom: number };
}

export const usePersistedPosition = ({
  storageKey,
  defaultPosition,
}: UsePersistedPositionProps) => {
  const [relativePosition, setRelativePosition] = useState<RelativePosition>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {
      console.warn('Failed to load position from localStorage', e);
    }

    return {
      rightPercent: defaultPosition.right / window.innerWidth,
      bottomPercent: defaultPosition.bottom / window.innerHeight,
    };
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(relativePosition));
    } catch (e) {
      console.warn('Failed to save position to localStorage', e);
    }
  }, [relativePosition, storageKey]);

  return { relativePosition, setRelativePosition };
};
